import { ComponentProps } from "react";

import { useT } from "@/i18n";
import { getIconSize, IconSize } from "@/ui";
import { cn } from "@/utils/cn";
import { getAvatarPlaceholderUrl, resolveLogoUrl } from "@/utils/common";

export type ClubLogoProps = {
  club: { name: string; logoFile: { url: string | null } | null; legacyLogoUrl: string | null };
  width?: number;
  height?: number;
  size?: IconSize;
} & Omit<ComponentProps<"img">, "src" | "alt" | "aria-label">;

export const ClubLogo = ({ club, className, width, height, size, ...props }: ClubLogoProps) => {
  const t = useT();

  const label = t("club.components.logo.label", {
    name: club.name,
  });

  const sizePx = getIconSize(size);

  return (
    <img
      src={resolveLogoUrl(club) || getAvatarPlaceholderUrl(club.name)}
      alt={label}
      aria-label={label}
      style={{ width: width ?? sizePx, height: height ?? sizePx }}
      className={cn("shrink-0 object-contain rounded-sm", className)}
      {...props}
    />
  );
};
